import { Grid } from "@mui/material";
import DataHubTable from "./components/DataHubTable";
import { useDataHubCustomerBuildings } from "./hooks";
import { string, func, object } from "prop-types";
import React from "react";

interface DatahubBuildingsProps {
  view?: string;
  setView?: (view: string) => void;
  id?: string;
  setSelectedItem?: (item: any) => void;
  selectedItem?: any;
  gettext?: (key: string) => string;
}

const DatahubBuildings = (props: DatahubBuildingsProps) => {
  const { view, setView, id, setSelectedItem, selectedItem, gettext } = props;
  const { buildingsList, loading } = useDataHubCustomerBuildings(id);

  return (
    <Grid>
      <DataHubTable
        title={view}
        setView={setView}
        view={view}
        rows={buildingsList}
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        gettext={gettext}
        loading={loading}
      />
    </Grid>
  );
};
export default DatahubBuildings;

DatahubBuildings.propTypes = {
  view: string,
  setView: func,
  id: string,
  setSelectedItem: func,
  selectedItem: object,
  gettext: func,
};
